import { getLocalData, _languageName } from "../helpers/localData";

interface textChooserRenderProps {
    code: string;
    wrapper: "p" | "h1" | "h2" | "h3" | "div";
    replacebles?: (string | number)[];
}

export const textChooser = (code: string , replacebles: (string | number)[] = []): string => {
    let userSettings = getLocalData(_languageName);
    let userLanguage = require(`../../assets/json/lang/${userSettings ?? "es-PE"}.json`);

    let textChosed = userLanguage[code];
    let text = textChosed ? textChosed : "No Text";

    replacebles.forEach((replace) => {
        let newText = text.replace("{*}", replace);
        text = newText;
    })

    return text;
}

export const textChooserRender = ({code , replacebles, wrapper}: textChooserRenderProps) => {
    const element = document.createElement(wrapper);
    const text = textChooser(code, [...replacebles ?? []]);

    element.innerText = text;

    return element;
}